import { useStaticQuery, graphql } from 'gatsby'

export default function useGetSiteMetadata() {
    const data = useStaticQuery(graphql`
        query {
            site{
                siteMetadata{
                    title
                    siteUrl
                    brandName
                }
            }
        }
    `)
    return data.site.siteMetadata
}
